module.exports = __webpack_public_path__ + "static/media/email.c2a8677c.svg";